// The Tab title field is hidden, so a tab title equal to the persisted name
// was derived from it and follows a rename; any other value was set explicitly.
export const deriveTabTitle = ({
  name,
  tabTitle,
  persistedName,
}: {
  name: string;
  tabTitle: string;
  persistedName: string;
}): string => {
  const trimmedTabTitle = tabTitle.trim();

  if (!trimmedTabTitle || trimmedTabTitle === persistedName.trim()) {
    return name.trim();
  }

  return trimmedTabTitle;
};
